import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { healthCheckProxyDataProvider, RESOURCE } from './dataProvider';

registerModuleDataProvider(RESOURCE, healthCheckProxyDataProvider);
